// frontend/src/pages/LoginPage.js
import React, { useState } from 'react';
import { useAuth } from '../auth/AuthContext';
import { useNavigate, useLocation, Link, Navigate } from 'react-router-dom';
import Footer from '../components/Footer';
import logo from '../assets/icons/iconoGestionEJP.png';

const LoginPage = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState('');
    const { login, isAuthenticated } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();

    const from = location.state?.from?.pathname || "/home";

    // Si ya está autenticado, redirigir al home interno
    if (isAuthenticated) {
        return <Navigate to="/home" replace />;
    }
    const successMessage = location.state?.message;

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        try {
            await login(email, password);
            navigate(from, { replace: true });
        } catch (err) {
            console.error("Error en login:", err);
            if (err.response && err.response.data && err.response.data.message) {
                setError(err.response.data.message);
            } else if (err.response?.status === 401 || err.response?.status === 403) {
                setError('Credenciales incorrectas o cuenta pendiente de validación.');
            } else {
                setError('Error al iniciar sesión. El servidor no responde.');
            }
        }
    };

    return (
        <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
            <style>{`
                .pub-nav-tabs { position: absolute; left: 50%; transform: translateX(-50%); display: flex; align-items: center; gap: 0.25rem; }
                .pub-nav-title { display: inline; }
                .pub-nav-login-text { display: inline; }
                .pub-nav-login-icon { display: none; }
                .login-grid { display: grid; grid-template-columns: 1fr 1fr; max-width: 1000px; width: 100%; background: white; border-radius: 20px; box-shadow: 0 8px 32px rgba(0,0,0,0.1); overflow: hidden; }
                .login-illustration { background: #f8f9fa; padding: 3rem; display: flex; flex-direction: column; align-items: center; justify-content: center; }
                .login-form-col { padding: 3rem; display: flex; flex-direction: column; justify-content: center; }
                @media (max-width: 768px) {
                    .pub-nav-tabs { position: static; transform: none; left: auto; }
                    .pub-nav-title { display: none; }
                    .pub-nav-mobile-title { display: inline !important; }
                    .pub-nav-login-text { display: none; }
                    .pub-nav-login-icon { display: inline; }
                    .login-grid { grid-template-columns: 1fr; }
                    .login-illustration { display: none; }
                    .login-form-col { padding: 2rem 1.5rem; }
                }
            `}</style>

            {/* ===== NAVBAR ===== */}
            <nav style={{
                position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1100, height: '70px',
                background: 'var(--primary)',
                boxShadow: 'var(--shadow-md)',
                display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0 1.5rem',
            }}>
                <button
                    onClick={() => navigate('/')}
                    style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'white', fontWeight: 600, fontSize: '1.15rem', fontFamily: "'Inter','Segoe UI',sans-serif", display: 'flex', alignItems: 'center', gap: '0.6rem', padding: 0, flexShrink: 0 }}
                >
                    <span className="pub-nav-title">Estudio Jurídico Previsional</span>
                    <span className="pub-nav-mobile-title" style={{ display: 'none' }}>GestiónEJP</span>
                </button>
                {/* Tabs centrados de forma absoluta */}
                <div className="pub-nav-tabs">
                    <button
                        onClick={() => navigate('/')}
                        style={{
                            background: 'none', border: 'none', borderBottom: '2px solid transparent',
                            padding: '0.5rem 1rem', fontSize: '0.9rem', fontWeight: 400,
                            color: 'rgba(255,255,255,0.75)', cursor: 'pointer', transition: 'all 0.2s ease',
                            display: 'flex', alignItems: 'center', gap: '0.4rem', whiteSpace: 'nowrap', height: '70px',
                        }}
                        onMouseEnter={(e) => { e.currentTarget.style.color = 'white'; }}
                        onMouseLeave={(e) => { e.currentTarget.style.color = 'rgba(255,255,255,0.75)'; }}
                    >
                        <i className="bi bi-house-door"></i>
                        Inicio
                    </button>
                    <button
                        onClick={() => navigate('/', { state: { seccion: 'nosotros' } })}
                        style={{
                            background: 'none', border: 'none', borderBottom: '2px solid transparent',
                            padding: '0.5rem 1rem', fontSize: '0.9rem', fontWeight: 400,
                            color: 'rgba(255,255,255,0.75)', cursor: 'pointer', transition: 'all 0.2s ease',
                            display: 'flex', alignItems: 'center', gap: '0.4rem', whiteSpace: 'nowrap', height: '70px',
                        }}
                        onMouseEnter={(e) => { e.currentTarget.style.color = 'white'; }}
                        onMouseLeave={(e) => { e.currentTarget.style.color = 'rgba(255,255,255,0.75)'; }}
                    >
                        <i className="bi bi-info-circle"></i>
                        Sobre Nosotros
                    </button>
                </div>
                <div style={{ background: 'rgba(255,255,255,0.25)', border: '1.5px solid rgba(255,255,255,0.6)', borderRadius: '8px', padding: '0.45rem 1.1rem', color: 'white', fontWeight: 600, fontSize: '0.9rem', display: 'flex', alignItems: 'center', gap: '0.5rem', fontFamily: "'Inter', 'Segoe UI', sans-serif", flexShrink: 0 }}>
                    <i className="bi bi-box-arrow-in-right pub-nav-login-icon"></i>
                    <span className="pub-nav-login-text">Iniciar Sesión</span>
                </div>
            </nav>

            {/* Contenido */}
            <div style={{ flex: 1, background: 'var(--bg-page)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '1.5rem', paddingTop: '70px', paddingBottom: '2rem' }}>
                <div className="login-grid">
                    {/* Columna ilustración */}
                    <div className="login-illustration">
                        <div style={{ marginBottom: '2rem' }}>
                            <img src={logo} alt="Logo GestiónEJP" style={{ width: '280px', height: 'auto', display: 'block' }} />
                        </div>
                        <h2 style={{ fontSize: '1.5rem', fontWeight: 600, textAlign: 'center', color: '#2c3e50', margin: 0 }}>
                            Gestión de Trámites Previsionales
                        </h2>
                    </div>

                    {/* Columna formulario */}
                    <div className="login-form-col">
                        <div style={{ marginBottom: '1.5rem' }}>
                            <h3 style={{ fontSize: '1.75rem', fontWeight: 700, color: '#1e293b', marginBottom: '0.5rem' }}>
                                Iniciar Sesión
                            </h3>
                            <p style={{ color: '#64748b', fontSize: '0.95rem' }}>
                                Ingresá con tus credenciales autorizadas
                            </p>
                        </div>

                        <div style={{
                            background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: '10px',
                            padding: '0.65rem 0.85rem', marginBottom: '1.25rem',
                            display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '0.8rem', color: '#1e40af',
                        }}>
                            <i className="bi bi-info-circle-fill"></i>
                            Acceso exclusivo para personal autorizado del estudio.
                        </div>

                        {successMessage && (
                            <div style={{
                                background: 'var(--gradient-success)',
                                color: 'white', padding: '1rem', borderRadius: '10px',
                                marginBottom: '1.25rem', fontSize: '0.9rem',
                            }}>
                                <strong style={{ display: 'block', marginBottom: '0.25rem' }}>✓ Registro Exitoso</strong>
                                {successMessage}
                            </div>
                        )}

                        <form onSubmit={handleSubmit}>
                            <div style={{ marginBottom: '1.25rem' }}>
                                <label style={{
                                    display: 'block', fontWeight: 600, color: '#374151',
                                    marginBottom: '0.5rem', fontSize: '0.9rem',
                                }}>
                                    <i className="bi bi-envelope me-2" style={{ color: '#3B82F6' }}></i>
                                    Correo Electrónico
                                </label>
                                <input
                                    type="email" placeholder="tu.email@estudio.com"
                                    value={email} onChange={(e) => setEmail(e.target.value)}
                                    required autoComplete="email"
                                    style={{ width: '100%', padding: '0.75rem 1rem',
                                        border: '2px solid #e5e7eb',   transition: 'all 0.2s ease',
                                        outline: 'none', boxSizing: 'border-box' }}
                                    onFocus={(e) => e.target.style.border = '2px solid #3B82F6'}
                                    onBlur={(e) => e.target.style.border = '2px solid #e5e7eb'}
                                />
                            </div>

                            <div style={{ marginBottom: '1.25rem' }}>
                                <label style={{
                                    display: 'block', fontWeight: 600, color: '#374151',
                                    marginBottom: '0.5rem', fontSize: '0.9rem',
                                }}>
                                    <i className="bi bi-lock me-2" style={{ color: '#3B82F6' }}></i>
                                    Contraseña
                                </label>
                                <div style={{ position: 'relative' }}>
                                    <input
                                        type={showPassword ? 'text' : 'password'}
                                        placeholder="Ingresá tu contraseña"
                                        value={password} onChange={(e) => setPassword(e.target.value)}
                                        required autoComplete="current-password"
                                        style={{ width: '100%', padding: '0.75rem 3rem 0.75rem 1rem',
                                            border: '2px solid #e5e7eb',   transition: 'all 0.2s ease',
                                            outline: 'none', boxSizing: 'border-box' }}
                                        onFocus={(e) => e.target.style.border = '2px solid #3B82F6'}
                                        onBlur={(e) => e.target.style.border = '2px solid #e5e7eb'}
                                    />
                                    {password && (
                                        <button
                                            type="button" onClick={() => setShowPassword(!showPassword)}
                                            style={{
                                                position: 'absolute', right: '0.75rem', top: '50%',
                                                transform: 'translateY(-50%)', background: 'none',
                                                border: 'none', cursor: 'pointer', color: '#64748b',
                                                fontSize: '1.2rem', padding: '0.25rem',
                                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                transition: 'color 0.2s ease',
                                            }}
                                            onMouseEnter={(e) => e.currentTarget.style.color = '#3B82F6'}
                                            onMouseLeave={(e) => e.currentTarget.style.color = '#64748b'}
                                            title={showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}
                                        >
                                            <i className={`bi ${showPassword ? 'bi-eye-slash' : 'bi-eye'}`}></i>
                                        </button>
                                    )}
                                </div>
                            </div>

                            {error && (
                                <div style={{
                                    background: '#FEF2F2', border: '2px solid #FCA5A5',
                                    color: '#991B1B', padding: '0.875rem', borderRadius: '10px',
                                    marginBottom: '1.25rem', fontSize: '0.9rem',
                                    display: 'flex', alignItems: 'center',
                                }}>
                                    <i className="bi bi-exclamation-triangle-fill me-2" style={{ fontSize: '1.1rem' }}></i>
                                    <span>{error}</span>
                                </div>
                            )}

                            <button
                                type="submit"
                                style={{
                                    width: '100%', padding: '0.875rem',
                                    background: 'var(--primary)',
                                    color: 'white', border: 'none', borderRadius: '10px',
                                    fontSize: '1rem', fontWeight: 600, cursor: 'pointer',
                                    transition: 'all 0.2s ease', boxShadow: 'var(--shadow-md)',
                                }}
                                onMouseEnter={(e) => { e.target.style.transform = 'translateY(-2px)'; e.target.style.boxShadow = '0 6px 16px rgba(59, 130, 246, 0.4)'; }}
                                onMouseLeave={(e) => { e.target.style.transform = 'translateY(0)'; e.target.style.boxShadow = '0 4px 12px rgba(59, 130, 246, 0.3)'; }}
                            >
                                <i className="bi bi-box-arrow-in-right me-2"></i>
                                Ingresar
                            </button>
                        </form>

                        <div style={{
                            textAlign: 'center', marginTop: '1.5rem',
                            paddingTop: '1.25rem', borderTop: '1px solid #e5e7eb',
                        }}>
                            <Link to="/register" style={{ color: '#3B82F6', textDecoration: 'none', fontWeight: 500, fontSize: '0.9rem' }}>
                                <i className="bi bi-person-plus me-2"></i>
                                ¿No tenés cuenta? Solicitá acceso aquí
                            </Link>
                            <div style={{
                                marginTop: '0.75rem', display: 'flex', justifyContent: 'center',
                                gap: '1.5rem', fontSize: '0.78rem',
                            }}>
                                <Link to="/politica-privacidad" style={{ color: '#94a3b8', textDecoration: 'none' }}
                                    onMouseEnter={(e) => e.target.style.color = '#3b82f6'}
                                    onMouseLeave={(e) => e.target.style.color = '#94a3b8'}>
                                    Política de Privacidad
                                </Link>
                                <Link to="/terminos" style={{ color: '#94a3b8', textDecoration: 'none' }}
                                    onMouseEnter={(e) => e.target.style.color = '#3b82f6'}
                                    onMouseLeave={(e) => e.target.style.color = '#94a3b8'}>
                                    Términos de Uso
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default LoginPage;

